module.exports = __webpack_public_path__ + "static/media/leap.f55a8bd8.jpeg";